import React, {useEffect, useState} from 'react';
import ReactChipInput from "react-chip-input";
import {arrayIncludeItem} from "@app/utils/CommonUtils";
import {cloneDeep} from "lodash";
import {LATEST_STABLE_LEVELS} from "@app/constants/Common";
import Select from "react-select";
import {AREA_OPTIONS, PROVINCE_OPTIONS} from "@app/constants/Provinces";
import {JobStatusOptions} from "@pages/job/common/Constant";

const SearchJobCategoryContent = (props) => {
    const [searchInput, setSearchInput] = useState({});

    const {onChange, advanceSearchInput} = props

    const onChangeSearchInputInfo = (fieldName, value) => {
        searchInput[fieldName] = value
        setSearchInput({...searchInput})
        if (onChange) {
            onChange(searchInput)
        }
    };

    const onAddIndustryFunction = (fieldName, value) => {
        if (!value) {
            return;
        }
        let arr = cloneDeep(searchInput[fieldName])
        if (!arr) {
            arr = []
        }

        if (!arrayIncludeItem(arr, value)) {
            arr.push(value)
            searchInput[fieldName] = arr
            setSearchInput({...searchInput})
            if (onChange) {
                onChange(searchInput)
            }
        } else {
            alert('Không được phép nhập các giá trị giống nhau tại cùng 1 trường.')
        }
    }

    const onRemoveIndustryFunction = (index, fieldName) => {
        let arr = cloneDeep(searchInput[fieldName])
        if (arr && arr.length > 0) {
            if (arr.length === 1) {
                arr = []
            } else {
                arr.splice(index, 1);
            }
            searchInput[fieldName] = arr
            setSearchInput({...searchInput})
            if (onChange) {
                onChange(searchInput)
            }
        }
    }

    useEffect(() => {
        setSearchInput(advanceSearchInput)
    }, [advanceSearchInput])

    return (
        <div className='card card-default'>
            <div className='card-header'>
                <h3 className='card-title text-bold'>Phân loại</h3>
            </div>
            <div className='card-body'>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Industry</label>
                    <div style={{width: '100%'}}>
                        <ReactChipInput
                            classes={`class1 class2 w-100`}
                            name={'industry'}
                            chips={searchInput.industry ? searchInput.industry : []}
                            onSubmit={value => onAddIndustryFunction('industry', value)}
                            onRemove={index => onRemoveIndustryFunction(index, 'industry')}
                        />
                    </div>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Function</label>
                    <div style={{width: '100%'}}>
                        <ReactChipInput
                            classes={`class1 class2 w-100`}
                            name={'function'}
                            chips={searchInput.function ? searchInput.function : []}
                            onSubmit={value => onAddIndustryFunction('function', value)}
                            onRemove={index => onRemoveIndustryFunction(index, 'function')}
                        />
                    </div>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}><b>Job Level</b></label>
                    <select className={`form-control`}
                            value={searchInput.job_level}
                            name={'job_level'}
                            onChange={event => onChangeSearchInputInfo("job_level", event.target.value)}>
                        {LATEST_STABLE_LEVELS.map((item, index) => {
                            return <option value={item.toLowerCase()}>{item}</option>
                        })}
                    </select>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}><b>Location (Tỉnh)</b></label>
                    <div style={{width: '100%'}}>
                        <Select options={PROVINCE_OPTIONS} isMulti
                                value={searchInput.local_province}
                                onChange={value => {
                                    onChangeSearchInputInfo("local_province", value);
                                }}
                        />
                    </div>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}><b>Location (Miền)</b></label>
                    <div style={{width: '100%'}}>
                        <Select options={AREA_OPTIONS} isMulti
                                value={searchInput.local_area}
                                onChange={value => {
                                    onChangeSearchInputInfo("local_area", value);
                                }}
                        />
                    </div>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Job Status</label>
                    <div style={{width: '100%'}}>
                        <Select options={JobStatusOptions}
                                value={searchInput.job_status}
                                onChange={value => {
                                    onChangeSearchInputInfo("job_status", value);
                                }}
                        />
                    </div>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Job date</label>
                    <div className=' col-sm-6'>
                        <div style={{width: '100%'}}>
                            <div className="form-group">
                                {/*<label>Ngày bắt đầu</label>*/}
                                <input type="date"
                                       className="form-control" name={'created_start_date'}
                                       value={searchInput.created_start_date}
                                       onChange={event => onChangeSearchInputInfo('created_start_date', event.target.value)}
                                       maxLength="10" placeholder="mm/dd/yyyy" autoComplete="off"/>
                            </div>
                        </div>
                    </div>
                    <div className='col-sm-6'>
                        <div style={{width: '100%'}}>
                            <div className="form-group">
                                {/*<label className={'w-100'}><b>Ngày kết thúc</b></label>*/}
                                <input type="date"
                                       className="form-control" name={'created_end_date'}
                                       value={searchInput.created_end_date}
                                       onChange={event => onChangeSearchInputInfo('created_end_date', event.target.value)}
                                       maxLength="10" placeholder="mm/dd/yyyy" autoComplete="off"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SearchJobCategoryContent;
